module.exports = __webpack_public_path__ + "static/media/shipment-sofa.1b29c308.svg";